import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { colors } from '../../../theme';

export interface FooterProps {
  className?: string;
}

const FOOTER_COLS = [
  {
    title: 'About',
    links: [
      { label: 'About CAR-IA', to: '/about' },
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Careers', to: '/careers' },
      { label: 'Blog', to: '/blog' },
      { label: 'Press', to: '/press' },
    ],
  },
  {
    title: 'Buy',
    links: [
      { label: 'Browse Catalog', to: '/feed' },
      { label: 'Search by Brand', to: '/feed' },
      { label: 'Featured Vehicles', to: '/feed' },
      { label: 'Trust Signals', to: '/trust' },
    ],
  },
  {
    title: 'Sell',
    links: [
      { label: 'List Your Vehicle', to: '/sell' },
      { label: 'How to Sell', to: '/sell/guide' },
      { label: 'Dealer Plans', to: '/dealers' },
      { label: 'Seller Resources', to: '/sell/resources' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help Center', to: '/help' },
      { label: 'Trust & Safety', to: '/safety' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Social Media',
    links: [
      { label: 'LinkedIn', to: '/linkedin' },
      { label: 'Facebook', to: '/facebook' },
      { label: 'Instagram', to: '/instagram' },
    ],
  },
];

export const Footer: React.FC<FooterProps> = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: colors.primary.main,
        color: 'white',
        pt: 6,
        pb: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {FOOTER_COLS.map((col) => (
            <Grid item xs={6} sm={4} md key={col.title}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'white', mb: 1.5, fontSize: '0.95rem' }}
              >
                {col.title}
              </Typography>
              {col.links.map((link) => (
                <Box key={link.label} sx={{ mb: 0.75 }}>
                  <Link
                    to={link.to}
                    style={{
                      color: 'rgba(255,255,255,0.85)',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                    }}
                  >
                    {link.label}
                  </Link>
                </Box>
              ))}
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: '1px solid rgba(255,255,255,0.2)',
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
            © {new Date().getFullYear()} CAR-IA. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
